import axios from 'axios';

import {API_ROOT} from './config';

export default {
  /**
   * Get the campaign data with voter verification
   * @param  {String} shortCode      - the meeting short code
   * @param  {String} trackingCode   - the voter tracking code
   * @param  {String} token          - the signed voter token
   */
  getMeeting(shortCode, voterKey, token) {
    // If token is provided, then we send it in header. Otherwise, we're sending vk in query.
    // @TODO: Deprecate the vk method.
    const config = token
      ? {headers: {Authorization: `Bearer ${token}`}}
      : {params: {vk: voterKey}};
    return axios.get(`${API_ROOT}/Public/meetings/${shortCode}/`, config);
  },

  /**
   * Save submission via API
   * @param  {Object} submission - the submission object
   * @param  {String} token      - the signed voter token
   */
  saveSubmission(submission, token) {
    // If token is provided, then we send it in header. Otherwise, we're sending vk in query.
    // @TODO: Deprecate the vk method.
    const config = token
      ? {headers: {Authorization: `Bearer ${token}`}}
      : {headers: {'X-Voter-Key': `${submission.trackingCode}`}};

    const shortCode = submission.shortCode;
    return axios.post(
      `${API_ROOT}/Public/meetings/${shortCode}/actions/submit-proxy`,
      submission,
      config
    );
  },

  /**
   * Get the submission HTML for review
   * @param  {Object} submission - the submission object
   * @param  {String} token      - the signed voter token
   */
  getProxyContent(submission, token) {
    // If token is provided, then we send it in header. Otherwise, we're sending vk in query.
    // @TODO: Deprecate the vk method.
    const config = token
      ? {headers: {Authorization: `Bearer ${token}`}}
      : {headers: {'X-Voter-Key': `${submission.trackingCode}`}};

    const shortCode = submission.shortCode;
    return axios.post(
      `${API_ROOT}/Public/meetings/${shortCode}/actions/review-proxy`,
      submission,
      config
    );
  },

  /**
   * Log a voter action
   * @param  {String} action       - the action conducted by voter
   * @param  {String} shortCode    - the meeting short code
   * @param  {String} trackingCode - the tracking key
   * @param  {Object} data         - the action description payload
   * @param  {String} token        - the signed voter token
   */
  sendVoterAction(action, shortCode, trackingCode, data, token) {
    // If token is provided, then we send it in header. Otherwise, we're sending vk in query.
    // @TODO: Deprecate the vk method.
    const config = token
      ? {headers: {Authorization: `Bearer ${token}`}}
      : {headers: {'X-Voter-Key': `${trackingCode}`}};

    const ua = window.navigator.userAgent;
    const actionObject = {
      shortCode: shortCode,
      action: action,
      data: {...data, trackingCode, ua, signedToken: !!token}
    };
    return axios.post(
      `${API_ROOT}/Public/meetings/${shortCode}/actions/log-event`,
      actionObject,
      config
    );
  },

  /**
   * Mark a voter as RSVP'd
   * @param  {String}  shortCode    - the meeting short code
   * @param  {String}  token        - the signed voter token
   * @param  {Boolean} attending    - if the owner is attending
   */
  postVoterAttending(shortCode, token, attending = false) {
    if (!token) {
      throw new Error('No Token Available');
    }

    const config = {headers: {Authorization: `Bearer ${token}`}};
    const payload = {isAttending: !!attending};

    return axios.post(
      `${API_ROOT}/Public/meetings/${shortCode}/actions/set-attending`,
      payload,
      config
    );
  },

  /**
   * Self revoke submissions
   * @param  {String}  shortCode    - the meeting short code
   * @param  {String}  token        - the signed voter token
   */
  postRevokeSubmissions(shortCode, token) {
    if (!token) {
      throw new Error('No Token Available');
    }

    const config = {headers: {Authorization: `Bearer ${token}`}};
    return axios.post(
      `${API_ROOT}/Public/meetings/${shortCode}/actions/revoke-all`,
      {},
      config
    );
  }
};



// WEBPACK FOOTER //
// ./src/api.js